export const imagePathToSmallImagePath = (path) => {
  return path.replace('/uploads/', '/uploads_small/');
};
